// Pages that open inside the app (components/InAppWebView), never in the
// phone's browser. Used by Login (Terms / Privacy) and Profile (About, Terms,
// Privacy).
export const WEB_PAGES = {
  about: 'https://pompi.nl/about-pompi.html',
  terms: 'https://home.pompi.nl/terms-and-conditions.html',
  privacy: 'https://home.pompi.nl/privacy-policy.html',
};